import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ProductCard from '@/components/feature/ProductCard';
import { categories, allProducts } from '@/mocks/data';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];

  if (!slug || !categories.find((c) => c.slug === slug)) {
    const firstCat = categories[0];
    window.location.href = `/category/${firstCat.slug}`;
    return null;
  }

  const filteredProducts = allProducts.filter((p) => p.category === slug);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-20">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '分类浏览', path: '/category/vibration-clamps' },
              { name: currentCategory.name },
            ]}
          />
        </div>

        {/* Category Header */}
        <section className="relative w-full h-[300px] md:h-[360px] flex items-center overflow-hidden">
          <img
            src={currentCategory.image}
            alt={currentCategory.name}
            title={currentCategory.name}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
            <span className="inline-block bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium px-3 py-1 rounded-full mb-3">
              {currentCategory.productCount} 款产品
            </span>
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-background-50 mb-3">
              {currentCategory.name}
            </h1>
            <p className="text-background-200 text-sm md:text-base max-w-xl">
              {currentCategory.description}
            </p>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="sticky top-16 z-40 bg-background-50 border-b border-background-200/70">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-1 py-3 overflow-x-auto scrollbar-hide">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Product Grid */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            {filteredProducts.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {filteredProducts.map((product) => (
                  <ProductCard key={product.id} {...product} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无产品</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}